module.exports = __webpack_public_path__ + "media/images/Okamoto-05310849adf915b05097a9c0ebd47111.jpg";